import "./NavFooter.css";

export const NavFooter = () => {

  return (
    <div className="center nf-container">©2021 BY CAT & MILL</div>
  )
}